var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { width: "510" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ attrs, on }) {
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            ripple: false,
                            small: _vm.small,
                            color: "warning",
                            outlined: "",
                          },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _vm._v(" Ad Event คืออะไร "),
                      _c("v-icon", { attrs: { right: "" } }, [
                        _vm._v(" mdi-help-circle "),
                      ]),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            { attrs: { color: "pa-2" } },
            [
              _c(
                "v-card-title",
                [
                  _c("div", { staticClass: "text-h2-headline primary--text" }, [
                    _vm._v(" Ad Event คืออะไร "),
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "" },
                      on: {
                        click: function ($event) {
                          return _vm.setDialog(false)
                        },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { small: "" } }, [
                        _vm._v(" mdi-close "),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-card-text", [
                _vm._v(
                  " ตัวช่วยที่จะทำให้การซื้อโฆษณาของร้านค้ามีประสิทธิภาพภาพมากขึ้น โดยอ้างอิงจากการของขายในระบบ Message ของ Facebook "
                ),
                _c("br"),
                _vm._v(
                  " ร้านค้าสามารถกำหนดสถานะของออเดอร์และมูลค่าที่ต้องการได้ "
                ),
                _c("br"),
                _vm._v(
                  " ซึ่งการเก็บข้อมูลนั้นจะเกิดขึ้นได้เพียงออเดอร์ละ 1 ครั้งเท่านั้น "
                ),
                _c("br"),
                _vm._v(
                  " ระบบจะนำข้อมูลดังกล่าวไป optimize ให้การซื้อโฆษณานั้นตรงกลุ่มเป้าหมาย "
                ),
                _c("br"),
                _vm._v(" มากยิ่งขึ้น "),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }